import React from "react";

const ComingSoon = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-[rgba(67,171,223,0.55)] relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-96 h-96 bg-[rgb(239,68,68)] rounded-full blur-[100px] opacity-30"></div>
      </div>

      <div className="z-10 text-center p-8 rounded-lg shadow-2xl bg-gradient-to-br from-[rgb(239,68,68)] to-[rgb(2,93,137)] max-w-2xl mx-auto">
        {/* Decorative Vector */}
        <div className="mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            className="w-16 h-16 mx-auto animate-pulse"
          >
            <path d="M12 0L9.09 8H0l7.455 5.417L4.545 24 12 18.292 19.455 24l-2.91-10.583L24 8h-9.09L12 0z" />
          </svg>
        </div>
        {/* Title */}
        <h1 className="text-5xl font-bold text-white mb-4 drop-shadow-lg">
          Coming Soon!
        </h1>
        {/* Description */}
        <p className="text-white text-lg mb-8 drop-shadow-lg">
          We're building something amazing for you. Stay connected for the big
          reveal!
        </p>
        {/* Call-to-Action */}
       
      </div>

      {/* Additional Background Vector */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[rgb(239,68,68)] rounded-full blur-[120px] opacity-40"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-[rgb(2,93,137)] rounded-full blur-[120px] opacity-30"></div>
    </div>
  );
};

export default ComingSoon;
